module.exports = __webpack_public_path__ + "logo.jpg?3a57815cf5af2c881e7a20955611a07f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.jpg
// module id = 646
// module chunks = 0